import { ProductBuilderState } from '../state'
import { ProductConfiguration } from '../../product'

export const productBuilderConfigurationSet = (state: ProductBuilderState, params: { productConfiguration: ProductConfiguration, productParameterKeepOpen: boolean }): ProductBuilderState => {
    return {
        ...state,
        product: {
            ...state.product,
            configuration: params.productConfiguration
        },
        productParameterExpandedKey: params.productParameterKeepOpen 
            ? state.productParameterExpandedKey
            : undefined
    }
}